import type { TourDefinition } from "@/types/tour";

export const entrepreneurOpportunityDetail: TourDefinition = {
  id: "entrepreneur-opportunity-detail",
  context: "entrepreneur",
  version: 1,
  path: "/matched-opportunity/",
  steps: [
    {
      element: '[data-tour-id="detail-scores"]',
      popover: {
        title: "Overall scores",
        description:
          "See how well this opportunity matches your profile across match, domain fit, execution fit, urgency, and difficulty.",
      },
    },
    {
      element: '[data-tour-id="detail-why-matched"]',
      popover: {
        title: "Why you matched",
        description:
          "Our AI explains why this opportunity fits your background, highlighting key reasons for the match.",
      },
    },
    {
      element: '[data-tour-id="detail-tabs"]',
      popover: {
        title: "Briefing, details & requirements",
        description:
          "Switch between these tabs to read the opportunity summary, detailed scope, and role requirements.",
      },
    },
    {
      element: '[data-tour-id="detail-apply"]',
      popover: {
        title: "Apply to this opportunity",
        description:
          "Interested? Click apply to submit your profile for this project. The team will review your application.",
      },
    },
  ],
};
